module.exports = __webpack_public_path__ + "img/icon-auth-user.1f8c060a.svg";